import Telegrafkollegiet from './Telegrafkollegiet';

export default Telegrafkollegiet;